module.exports = __webpack_public_path__ + "img/page_ct_bk1.88e5c545.png";